"use client";

import React from "react";
import { Mail, Loader as Loader2 } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
function SubscribeForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-secondary/10 border border-secondary/20 rounded-lg text-center animate-in fade-in duration-500">
        <p className="text-foreground font-medium text-lg">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="w-full max-w-md mx-auto space-y-4">
      <div className="flex flex-col sm:flex-row gap-3">
        <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1 space-y-0">
              <FormControl>
                <Input type="email" placeholder="Enter your email address" className="h-12 bg-background" {...field} />
              </FormControl>
            </FormItem>} />
        <Button type="submit" disabled={isSubmitting} className="h-12 px-8 w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader2 className="mr-2 size-4 animate-spin" />
              Subscribing...
            </> : "Subscribe"}
        </Button>
      </div>
      
      {}
      <FormField control={control} name="email" render={() => <FormItem className="space-y-0 text-left">
              <FormMessage />
            </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md text-left">
          <p className="text-destructive text-sm">{submitError}</p>
        </div>}
      
      <p className="text-xs text-muted-foreground text-center mt-4">
        By subscribing, you agree to our Privacy Policy. We respect your inbox.
      </p>
    </Form>;
}
export default function Subscribe() {
  return <section id="subscribe-for-tips" className="py-20 md:py-32 bg-background border-y border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center p-3 bg-secondary/10 rounded-lg mb-6">
            <Mail className="size-8 text-secondary" />
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
            Subscribe for Hospitality Revenue Tips
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
            Join thousands of hoteliers getting weekly industry insights, revenue management strategies, and exclusive tips delivered straight to their inbox.
          </p>

          <FormProvider formId="subscribe-tips-form" sectionName="subscribe-for-tips" defaultValues={{
          email: ""
        }} submitText="Subscribe" successMessage="Thank you for subscribing! Check your inbox for our latest insights.">
            <SubscribeForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}